import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dynamic-dependent-select"
export default class extends Controller {
  static targets = ["triggerField", "dependentField"]
  static values = {
    url: String,
    componentId: String
  }

  connect() {
    // Initial sync if trigger has a value
    this.updateAllDependents()
  }

  handleFieldChange(event) {
    this.updateAllDependents()
  }

  updateAllDependents() {
    this.triggerFieldTargets.forEach(trigger => {
      const triggerName = trigger.dataset.triggerField
      const triggerValue = trigger.value

      this.dependentFieldTargets.forEach(dependent => {
        const parentName = dependent.dataset.dependentParent
        if (parentName === triggerName) {
          this.fetchAndPopulateOptions(dependent, triggerValue)
        }
      })
    })
  }

  async fetchAndPopulateOptions(childElement, parentValue) {
    if (!parentValue) {
      this.clearAndDisable(childElement)
      return
    }

    try {
      const fieldIdentifier = childElement.dataset.fieldIdentifier
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.append("component_id", this.componentIdValue)
      url.searchParams.append("identifier", fieldIdentifier)
      url.searchParams.append("trigger_value", parentValue)

      const response = await fetch(url)
      if (!response.ok) throw new Error("Network response was not ok")
      
      const data = await response.json()
      this.updateChildOptions(childElement, data.results || [])
    } catch (error) {
      console.error("Dynamic lookup failed:", error)
      this.clearAndDisable(childElement)
    }
  }

  updateChildOptions(childElement, options) {
    const originalValue = childElement.dataset.originalValue
    const tomselectInstance = childElement.tomselect

    if (!tomselectInstance) {
      childElement.innerHTML = ""
      if (options.length === 0) {
        this.addOption(childElement, "Select a value", "", true)
        childElement.disabled = true
        return
      }
      childElement.disabled = false
      this.addOption(childElement, "Select an option", "")
      options.forEach(opt => {
        this.addOption(childElement, opt.text, opt.value, opt.value == originalValue)
      })
      return
    }

    tomselectInstance.clearOptions()
    if (options.length === 0) {
      tomselectInstance.addOption({ value: "", text: "Select a value" })
      tomselectInstance.setValue("")
      tomselectInstance.disable()
      return
    }

    tomselectInstance.enable()
    tomselectInstance.addOption({ value: "", text: "Select an option" })
    options.forEach(opt => {
      tomselectInstance.addOption({ value: opt.value, text: opt.text })
    })

    if (originalValue && options.some(o => o.value == originalValue)) {
      tomselectInstance.setValue(originalValue)
    } else {
      tomselectInstance.setValue("")
    }
  }

  addOption(element, text, value, selected = false) {
    const option = document.createElement("option")
    option.text = text
    option.value = value
    option.selected = selected
    element.add(option)
  }

  clearAndDisable(childElement) {
    const tomselectInstance = childElement.tomselect
    if (tomselectInstance) {
      tomselectInstance.clearOptions()
      tomselectInstance.addOption({ value: "", text: "Select a value" })
      tomselectInstance.setValue("")
      tomselectInstance.disable()
    } else {
      childElement.innerHTML = ""
      this.addOption(childElement, "Select a value", "")
      childElement.disabled = true
    }
  }
}
